/* tslint:disable */
/* eslint-disable */
/**
 * FleetManagement Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MeasurementSystem,
    MeasurementSystemFromJSON,
    MeasurementSystemFromJSONTyped,
    MeasurementSystemToJSON,
} from './';

/**
 * 
 * @export
 * @interface CurrentUserDto
 */
export interface CurrentUserDto {
    /**
     * 
     * @type {number}
     * @memberof CurrentUserDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    subjectId: string;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    isAdmin: boolean;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    organizationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    isoLanguageCode?: string | null;
    /**
     * 
     * @type {MeasurementSystem}
     * @memberof CurrentUserDto
     */
    measurementSystem?: MeasurementSystem;
    /**
     * 
     * @type {string}
     * @memberof CurrentUserDto
     */
    organizationAccessLevel?: string | null;
    /**
     *
     * @type {boolean}
     * @memberof CurrentUserDto
     */
    serviceReminderEnabled?: boolean;
}

export function CurrentUserDtoFromJSON(json: any): CurrentUserDto {
    return CurrentUserDtoFromJSONTyped(json, false);
}

export function CurrentUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subjectId': json['subjectId'],
        'email': json['email'],
        'isAdmin': json['isAdmin'],
        'organizationName': !exists(json, 'organizationName') ? undefined : json['organizationName'],
        'isoLanguageCode': !exists(json, 'isoLanguageCode') ? undefined : json['isoLanguageCode'],
        'measurementSystem': !exists(json, 'measurementSystem') ? undefined : MeasurementSystemFromJSON(json['measurementSystem']),
        'organizationAccessLevel': !exists(json, 'organizationAccessLevel') ? undefined : json['organizationAccessLevel'],
        'serviceReminderEnabled': !exists(json, 'serviceReminderEnabled') ? undefined : json['serviceReminderEnabled'],
    };
}

export function CurrentUserDtoToJSON(value?: CurrentUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'subjectId': value.subjectId,
        'email': value.email,
        'isAdmin': value.isAdmin,
        'organizationName': value.organizationName,
        'isoLanguageCode': value.isoLanguageCode,
        'measurementSystem': MeasurementSystemToJSON(value.measurementSystem),
        'organizationAccessLevel': value.organizationAccessLevel,
        'serviceReminderEnabled': value.serviceReminderEnabled,
    };
}


